import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SitesService {

    private baseUrl = environment.baseUrl + "/site";
    
    // constructor(public http: HttpClient) {
    // }

    constructor(public http: HttpClient) {
        console.log("Base URL:", this.baseUrl);
    }


    create(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/create", requestModel);
    };

    update(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/update", requestModel);
    };

    delete(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/delete", requestModel);
    };

    get(id: number): Observable<any> {
        return this.http.get(this.baseUrl + "/" + id);
    };

    list(filterModel): Observable<any> {
        return this.http.post(this.baseUrl + "/list", filterModel);
    };

    GetDadosPorTag(categoria: string, tagEpm: string): Observable<any> {
    return this.http.get(this.baseUrl + "/GetDadosPorTag", {
        params: {
            categoria: categoria,
            tagEpm: tagEpm
        }
    });
};
}
